import { isBuildingSelectModeAtom } from '@store';
import { Tooltip } from '@mui/material';
import IconHighlightAll from '@assets/icons/highlight-all';
import { MapControlButton } from '../styled';
import CypressIds from '../../../../cypressIds';

const SelectBuildings = () => {
  const [isBuildingSelectMode, setIsBuildingSelectMode] = useAtom(isBuildingSelectModeAtom);
  const { buildingId, featureId } = useParams();
  const handleClick = () => {
    setIsBuildingSelectMode(!isBuildingSelectMode);
  };

  const isDisabled = !!buildingId || !!featureId;

  return (
    <Tooltip title='Gebouwen selecteren' placement='bottom'>
      <MapControlButton
        disabled={isDisabled}
        onClick={handleClick}
        sx={{
          color: (theme) => (isBuildingSelectMode ? theme.palette.primary.main : '')
        }}
        data-cy={CypressIds.SELECT_MODE_BUTTON}
      >
        <IconHighlightAll />
      </MapControlButton>
    </Tooltip>
  );
};

export default SelectBuildings;
